import React, { Component } from 'react';
import EmailForm from '../../components/EmailForm';
import AuthApi from '../../services/api/auth';
import { SubmissionError, getFormSyncErrors, isDirty, getFormValues } from 'redux-form';
import LoadingModal from '../../components/LoadingModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';
import GdprScreen from '../Register/GdprScreen';
import Cookies from 'universal-cookie';
import {
    passwordMatch,
    passwordValidation,
    required,
    emailIsValid,
    emailIsValidChars,
    emailMatch,
    passwordStrengthValidation,
} from '../../inputs/validations';
import Helper from '../../helpers';
import jwt from 'jsonwebtoken';
import InvitationText from '../../components/InvitationText';
import ErrorList from '../../components/ErrorList';
import { setLanguage } from '../../redux/application/actions';
import { setCities, selectFleet } from '../../redux/cities/actions';
import { languageSelector, returnToSelector, isLightRegistrationSelector } from '../../redux/application/selector';
import FleetScreen from './FleetScreen';
import { selectedFleetSelector, citiesSelector } from '../../redux/cities/selector';
import moment from 'moment';

const cookies = new Cookies();

let signingParams = Helper.getUrlParams();

class EmailScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            loading: true,
            languageLoaded: false,
            fleetId: cookies.get('fleetId'),
            login: false,
            business: null,
            disableEmailInputField: false,
            isFranchise: false,
            fleetList: [],
            isTkExpired: true,
            isWrongFleetForBusiness: false,
            minPasswordStrength: window.VULOG_CONFIG.MIN_PASSWORD_STRENGTH,
            strength: 0,
        };
    }

    componentDidMount() {
        const { onSetCities, selectedFleet, location, history } = this.props;
        const { fleetId } = this.state;
        //this is a new session, remove cookie;

        AuthApi.loadConfig(this.state.fleetId, cookies.get('lang')).then(d => {
            window.SET_VULOG_DATA(d);
            this.props.setStep('EMAIL');
            let disableEmailInputField = false;
            /**
             * if there is a business token available, enable / disable the email input.
             */
            if (
                signingParams.tk &&
                window.VULOG_CONFIG.BUSINESS_REGISTRATION_DISABLE_EMAIL_FIELD &&
                window.VULOG_CONFIG.BUSINESS_REGISTRATION_PREFILL_EMAIL
            ) {
                disableEmailInputField = true;
            }
            this.setState({
                disableEmailInputField,
                languageLoaded: true,
            });

            if (window.VULOG_CONFIG.VULOG_FRONT_OFFICE_REALM && !selectedFleet && !signingParams.tk) {
                this.setState({ isFranchise: true });
                AuthApi.getCities(this.state.fleetId)
                    .then(response => onSetCities(response))
                    .catch(e => {
                        if (e && e.data && e.data.message) {
                            this.setState({ errors: [e.data.message, ...this.state.errors] });
                        }
                    });
            }

            if (
                selectedFleet &&
                selectedFleet !== fleetId &&
                window.VULOG_CONFIG.VULOG_FRONT_OFFICE_REALM &&
                fleetId.indexOf(window.VULOG_CONFIG.VULOG_FRONT_OFFICE_REALM) !== -1
            ) {
                const params = location.search ? location.search : '';
                let newRoute = location.pathname.replace(fleetId, selectedFleet);
                newRoute = `${newRoute}${params}`;
                history.push(newRoute);
                document.location.reload();
            }
        });

        if (signingParams.tk && jwt.decode(signingParams.tk)) {
            const parsedData = jwt.decode(signingParams.tk);

            if (window.VULOG_CONFIG.BUSINESS_REGISTRATION_PREFILL_EMAIL) {
                this.props.populateForm(
                    {
                        email: parsedData.email,
                    },
                    'email'
                );
            } else {
                this.props.populateForm(
                    {
                        email: '',
                    },
                    'email'
                );
            }
            this.setState({ business: parsedData });

            // if the fleet in the url doesn't match with the one from the token, we display an error message and we disable sign in / up button
            const { fleetId } = this.state;
            if (parsedData && fleetId !== parsedData.fleetId) {
                this.setState({ isWrongFleetForBusiness: true });
            }

            const expiration = moment.unix(parsedData.exp).utc();
            const now = moment().utc();
            this.setState({ isTkExpired: expiration.isBefore(now) });
        } else {
            this.setState({ isTkExpired: false });
        }

        const { language, onSetLanguage } = this.props;
        let defaultLocale = window.VULOG_CONFIG.DEFAULT_LANGUAGE || Object.keys(window.VULOG_CONFIG.LOCALE)[0];
        if (cookies.get('lang') || language) {
            this.setSelectedLanguageOption();
        } else if (signingParams.lang) {
            const selected = Object.keys(window.VULOG_CONFIG.LOCALE).find(
                locale => signingParams.lang.substring(0, 2) === locale.substring(0, 2)
            );
            if (selected) {
                onSetLanguage(selected);
                cookies.set('lang', selected);
            }
        } else {
            onSetLanguage(defaultLocale);
        }

        const authenticationToken = signingParams.token || signingParams.refreshToken;
        if (signingParams.refreshToken) {
            localStorage.setItem('refreshToken', signingParams.refreshToken);
        }
        if (authenticationToken) {
            AuthApi.tokenSigning(authenticationToken).then(response => {
                if (response.token) {
                    cookies.set('token', response.token, { path: '/' });
                }
                cookies.set('fleetId', response.fleetId);

                if (response.language) {
                    cookies.set('lang', response.language);
                }

                if (response.next) {
                    this.props.history.push(response.next);
                    this.setState({
                        loading: false,
                    });
                } else {
                    AuthApi.loadConfig(response.fleetId, cookies.get('lang')).then(d => {
                        window.SET_VULOG_DATA(d);
                        this.setState({
                            loading: false,
                        });

                        if (response.success) {
                            this.props.history.push('/register/status');
                        }
                    });
                }
            });
        } else {
            this.setState({
                loading: false,
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedFleet, cities, location, history, onSelectFleet } = this.props;
        const { fleetId } = this.state;
        // we check if the selected fleet has changed
        if (selectedFleet && selectedFleet !== prevProps.selectedFleet) {
            // and then if the current fleet is not the one selected, we reload the page with the good fleet
            if (fleetId && selectedFleet !== fleetId) {
                this.setState({ fleetId: selectedFleet });
                const params = location.search ? location.search : '';
                let newRoute = location.pathname.replace(fleetId, selectedFleet);
                newRoute = `${newRoute}${params}`;
                history.push(newRoute);
                document.location.reload();
            }
        }

        if (cities && cities !== prevProps.cities) {
            // we reduce the array to a list of fleet ids and we remove duplicates
            let fleetList = [...new Set(cities.map(city => city.fleetId))];
            // we keep only fleets that have a translation
            fleetList = fleetList.filter(fleetId => window.VULOG_TRANSLATIONS[fleetId]);
            const newFleetList = fleetList.map(fleet => ({ label: window.VULOG_TRANSLATIONS[fleet], value: fleet }));
            this.setState({ fleetList: newFleetList });

            // if the array has only one entry, the fleet is auto-selected and we don't display city screen
            if (newFleetList && newFleetList.length === 1) {
                return onSelectFleet(newFleetList[0].value);
            }

            // if no fleet is translated, we stay on the current fleet
            if (newFleetList && newFleetList.length === 0) {
                return onSelectFleet(fleetId);
            }
        }
    }

    onSubmit(data) {
        let validationMapping = {};

        if (this.state.login) {
            validationMapping = {
                email: [required, emailIsValid, emailIsValidChars],
                password: [required],
            };
        } else {
            const { strength, minPasswordStrength } = this.state;
            validationMapping = {
                email: [required, emailIsValid, emailIsValidChars],
                email2: window.VULOG_CONFIG.CONFIRM_EMAIL
                    ? [required, emailIsValid, emailIsValidChars, emailMatch]
                    : [],
                password:
                    window.VULOG_CONFIG.MIN_PASSWORD_STRENGTH > 0
                        ? [required, () => passwordStrengthValidation(strength, minPasswordStrength)]
                        : [required, passwordValidation],
                password2:
                    window.VULOG_CONFIG.MIN_PASSWORD_STRENGTH > 0
                        ? [required, passwordMatch, () => passwordStrengthValidation(strength, minPasswordStrength)]
                        : [required, passwordValidation, passwordMatch],
            };

            if (window.VULOG_CONFIG.EMAIL_REGISTRATION_CHECKBOXES && !this.state.login) {
                Object.keys(window.VULOG_CONFIG.EMAIL_REGISTRATION_CHECKBOXES).forEach(key => {
                    if (window.VULOG_CONFIG.EMAIL_REGISTRATION_CHECKBOXES[key].required) {
                        validationMapping[key] = [required];
                    }
                });
            }
        }

        this.setState({
            errors: {},
        });

        return new Promise(resolve => {
            let errors = {};
            Object.keys(validationMapping).forEach(key => {
                validationMapping[key].forEach(func => {
                    const message = func(data[key], data);
                    if (message) {
                        errors[key] = message;
                    }
                });
            });
            resolve(errors);
        }).then(errors => {
            if (Object.keys(errors).length > 0) {
                this.setState({
                    errors,
                });
                throw new SubmissionError(errors);
            }
            let signingParams = Helper.getUrlParams();

            this.setState({
                loading: true,
            });

            const datas = {
                ...data,
                fleetId: this.state.fleetId,
                language: this.props.language,
                businessToken: signingParams.tk,
            };

            return AuthApi.register(datas)
                .then(response => {
                    cookies.set('token', response.token, { path: '/' });
                    window.VULOG_CONFIG.STEPS = response.steps;
                    if (response.language) {
                        cookies.set('lang', response.language);
                    }

                    const { isLightRegistration, returnTo } = this.props;

                    if (isLightRegistration && !window.VULOG_CONFIG.STEPS.some(i => i.title === 'EMAIL_CHECK')) {
                        AuthApi.getRefreshToken(datas).then(response => {
                            this.setState(
                                {
                                    loading: false,
                                },
                                () => {
                                    document.location = `${returnTo}?refreshToken=${response.refreshToken}`;
                                }
                            );
                        });
                    } else {
                        AuthApi.getRefreshToken(datas).then(response => {
                            localStorage.setItem('refreshToken', response.refreshToken);
                        });
                        this.setState(
                            {
                                loading: false,
                            },
                            () => {
                                this.props.history.push(response.step);
                            }
                        );
                    }
                })
                .catch(response => {
                    const { login, message } = response.data;
                    if (login && (!this.state || (this.state && !this.state.login))) {
                        this.setState({
                            loading: false,
                            errors: [message],
                        });
                    } else {
                        this.setState({
                            loading: false,
                            errors: [message],
                        });
                        throw new SubmissionError({ _error: response.data.message });
                    }
                });
        });
    }

    changeLanguage = value => {
        const { onSetLanguage } = this.props;
        onSetLanguage(value);
        cookies.set('lang', value.substring(0, 2));
    };

    setSelectedLanguageOption = () => {
        const { language, onSetLanguage } = this.props;
        let defaultLocale =
            (window.VULOG_CONFIG && window.VULOG_CONFIG.DEFAULT_LANGUAGE) ||
            (window.VULOG_CONFIG && window.VULOG_CONFIG.LOCALE && Object.keys(window.VULOG_CONFIG.LOCALE)[0]);
        if (cookies.get('lang')) {
            const selected = Object.keys(window.VULOG_CONFIG.LOCALE).find(
                locale => cookies.get('lang').substring(0, 2) === locale.substring(0, 2)
            );
            return selected && onSetLanguage(selected);
        } else if (language) {
            const selected = Object.keys(window.VULOG_CONFIG.LOCALE).find(
                locale => language.substring(0, 2) === locale.substring(0, 2)
            );
            if (selected) {
                cookies.set('lang', selected.substring(0, 2));
                return onSetLanguage(selected);
            }
        }
        return onSetLanguage(defaultLocale);
    };

    getErrors = () => {
        const errors = { ...this.props.submitErrors, ...this.state.errors };
        let errorsList = [];
        Object.keys(errors).map(key => {
            return errorsList.push(`${key} ${errors[key]}`);
        });
        return errorsList;
    };

    onSelectFleet = fleetId => {
        const { onSelectFleet } = this.props;
        onSelectFleet(fleetId);
        this.setState({ errors: [] });
    };

    render() {
        const { login, selectedFleet } = this.props;
        const { isFranchise, errors, fleetList, strength, isTkExpired, isWrongFleetForBusiness } = this.state;
        if (!this.state.languageLoaded) {
            return null;
        }

        if (isFranchise && !selectedFleet && !signingParams.tk) {
            return (
                <FleetScreen
                    onSelectFleet={this.onSelectFleet}
                    selectedFleet={selectedFleet}
                    errors={errors}
                    fleetList={fleetList}
                />
            );
        }

        if (!cookies.get('gdpr') && window.VULOG_CONFIG.GDPR_REQUIRED) {
            return <GdprScreen isApps={signingParams.apps} />;
        }

        return (
            <div className="container-fluid wrapper">
                <LoadingModal loading={this.state.loading} />

                <div className="credentials-form__head">
                    {login ? (
                        <div className="page__title">
                            {window.VULOG_TRANSLATE('Login to continue your registration')}
                        </div>
                    ) : (
                        <div className="page__title">{window.VULOG_TRANSLATE("Let's get you started")}</div>
                    )}
                    {!login && (
                        <div className="page__title-medium">{window.VULOG_TRANSLATE('Create your login details')}</div>
                    )}
                </div>

                {this.state.business && !this.state.isWrongFleetForBusiness && !this.state.isTkExpired && (
                    <InvitationText data={this.state.business} />
                )}
                {this.state.business && this.state.isWrongFleetForBusiness && (
                    <div className="alert alert-danger">{window.VULOG_TRANSLATE('isWrongFleetForBusiness')}</div>
                )}
                {this.state.business && this.state.isTkExpired && (
                    <div className="alert alert-danger">{window.VULOG_TRANSLATE('businessTokenExpired')}</div>
                )}

                {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.getErrors()} />}

                <div className="form-group mt-2 mb-10">
                    <label htmlFor="phone-number" className="blue label-row">
                        {window.VULOG_TRANSLATE('Preferred Language')}
                    </label>
                    <select
                        className="custom-select"
                        value={this.props.language}
                        onChange={e => this.changeLanguage(e.target.value)}
                    >
                        {Object.keys(window.VULOG_LOCALE).map(key => {
                            return (
                                <option value={key} key={key}>
                                    {window.VULOG_LOCALE[key]}
                                </option>
                            );
                        })}
                    </select>
                </div>

                <EmailForm
                    {...this.props}
                    disableEmailInputField={this.state.login ? false : this.state.disableEmailInputField}
                    isBusiness={!!this.state.business}
                    login={this.state.login}
                    onSubmit={this.onSubmit.bind(this)}
                    errors={{ ...this.props.submitErrors, ...this.state.errors }}
                    setLogin={login => {
                        if (login) {
                            this.props.populateForm(
                                {
                                    email: '',
                                },
                                'email'
                            );
                        } else {
                            if (this.state.disableEmailInputField && this.state.business && this.state.business.email) {
                                this.props.populateForm(
                                    {
                                        email: this.state.business.email,
                                    },
                                    'email'
                                );
                            }
                        }
                        this.setState({
                            login,
                        });
                    }}
                    isTkExpired={isTkExpired}
                    strength={strength}
                    setStrength={strength => this.setState({ strength })}
                    isWrongFleetForBusiness={isWrongFleetForBusiness}
                    isApps={signingParams.apps}
                />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        initialValues: state.register.email,
        enableReinitialize: true,
        formValues: getFormValues('email')(state),
        submitErrors: getFormSyncErrors('email')(state),
        isDirty: isDirty('email')(state),
        language: languageSelector(state),
        returnTo: returnToSelector(state),
        isLightRegistration: isLightRegistrationSelector(state),
        cities: citiesSelector(state),
        selectedFleet: selectedFleetSelector(state),
    };
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

const mapDispatchToProps = dispatch => ({
    onRegisterActions: bindActionCreators(registerActions, dispatch),
    onSetLanguage: bindActionCreators(setLanguage, dispatch),
    onSetCities: bindActionCreators(setCities, dispatch),
    onSelectFleet: bindActionCreators(selectFleet, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(EmailScreen));
